import request from '@/utils/request'
let OrderApi = {
    /*订单列表*/
    orderlist(data) {
        return request._post('/shop/order.order/index', data);
    },
    /*订单详情*/
    orderdetail(data) {
        return request._post('/shop/order.order/detail', data);
    },
    /*批量发货*/
    batchDelivery(formData) {
      return request._upload('/shop/order.operate/batchDelivery', formData);
    },
    /*售后管理*/
    orderrefund(data) {
        return request._post('/shop/order.refund/index', data);
    },
    /*去发货*/
    delivery(data) {
        return request._post('/shop/order.order/delivery', data);
    },
    /*去配送*/
    deliveryStaff(data) {
        return request._post('/shop/order.order/deliveryStaff', data);
    },
    /*确认审核*/
    confirm(data) {
        return request._post('/shop/order.Operate/confirmCancel', data);
    },
    /*售后详情*/
    refundDetail(data) {
        return request._get('/shop/order.refund/detail', data);
    },
    /*售后审核*/
    Approval(data) {
        return request._get('/shop/order.refund/audit', data);
    },
    /*确认收货并退款*/
    receipt(data) {
        return request._post('/shop/order.refund/receipt', data);
    },
    /*核销*/
    extract(data) {
        return request._post('/shop/order.operate/extract', data);
    },
    /*修改价格*/
    updatePrice(data) {
        return request._post('/shop/order.order/updatePrice', data);
    },
    /*记录列表*/
    accountlog(data) {
        return request._get('/shop/order.order/accountlog', data);
    },
    /*修改后台备注*/
    remark(data) {
        return request._post('/shop/order.order/remark', data);
    },
    /*添加分销订单*/
    addAgentOrder(data, errorback) {
        return request._post('/shop/order.order/addAgentOrder', data, errorback);
    },
    /*手动结算*/
    settled(data, errorback) {
        return request._post('/shop/order.order/settled', data, errorback);
    },
    /*修改购买者*/
    editUserid(data) {
        return request._post('/shop/order.order/editUserid', data);
    },
    //获取订单服务项目
    getOrderService(data){
        return request._post('/shop/order.order/getOrderService', data);
    },
    //获取设备订单
      getEquipIndex(data){
        return request._post('/shop/order.equip/index', data);
    },
    //获取设备订单详情
    getEquipDetail(data){
        return request._post('/shop/order.equip/detail', data);
    },
    //审核设备订单退款
    confirmEquip(data){
        return request._post('/shop/order.equip/confirmEquip', data);
    },
    //删除订单
    del(data){
        return request._post('/shop/order.order/delOrder', data);
    },
    //删除设备订单
    delEquip(data){
        return request._post('/shop/order.equip/delOrder', data);
    },
}

export default OrderApi;



// WEBPACK FOOTER //
// ./src/api/order.js